import React from "react";

function Icon(props) {
  return (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        strokeLinejoin="round"
        strokeMiterlimit="2"
        clipRule="evenodd"
        viewBox="0 0 113 113"
        height={props.height ? props.height : "22px "}
    >
      <path
        className={props.pathClass ? props.pathClass : "black"}
        d="M679.261 1740.56l226.321-226.32a4.16 4.16 0 015.892 0l36.233 36.23a4.176 4.176 0 010 5.9l-226.321 226.32 226.321 226.32a4.164 4.164 0 010 5.89l-36.233 36.23a4.16 4.16 0 01-5.892 0l-226.321-226.32-226.321 226.32a4.162 4.162 0 01-5.893 0l-36.233-36.23a4.164 4.164 0 010-5.89l226.321-226.32-226.321-226.32a4.176 4.176 0 010-5.9l36.233-36.23a4.162 4.162 0 015.893 0l226.321 226.32z"
        transform="translate(-32.469 -176.925) scale(.1308)"
      ></path>
      <path
        fill="none"
        d="M7743.43 11233.1H7802.857V11302.999H7743.43z"
        transform="matrix(1.89741 0 0 1.60953 -14692.4 -18080)"
      ></path>
    </svg>
  );
}

export default Icon;
